import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/book');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions('book', validationApi);

export function getBookValidationHistoryOptions(bookId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(bookId);
}

export function getBookValidationOptions(bookId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(bookId);
}

export function useValidateBook(bookId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(bookId, queryClient));
}
